export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const CLEAR_NOTIFICATIONS_BY_TYPE = 'CLEAR_NOTIFICATIONS_BY_TYPE'
export const DELETE_EVENT_NOTIFICATION = 'DELETE_EVENT_NOTIFICATION'
export const SET_NOTIFICATIONS_BY_SUBTYPE = 'SET_NOTIFICATIONS_BY_SUBTYPE'
export const SET_INVALID_LOGIN_CHECK = 'SET_INVALID_LOGIN_CHECK'
